export const getSettingsOpen = store => store.toggleSettingsOpen;
export const getSettingsEnabled = store => store.setSettingsEnabled;
export const getAllDashboards = store => store.setAllDashboards;
export const getLoggedIn = store => store.setLoggedIn;
